import {
  LayoutDashboard, BarChart3, Star, Newspaper, LineChart, FileText, Settings, Sparkles,
  CalendarDays, UserSearch, TrendingUp, GitCompareArrows, Network,
  LayoutGrid, ArrowLeftRight, Target, BarChart2, AlertTriangle, Bell, MessageCircle,
  Compass, Search, Briefcase, Building2, Users, Zap, Gavel, BookOpen,
} from 'lucide-react';

// Items shared by both surfaces.
const sharedNav = [
  { path: '/public/ai', label: 'AI', icon: Sparkles },
  { path: '/public/watchlist', label: 'Watchlist', icon: Star, badge: 'watchlist' },
];

// Retail (KubAIr Research) — investor-facing surface.
const retailNav = [
  { path: '/public/home', label: 'Home', icon: LayoutDashboard },
  { path: '/public/ideas', label: 'Discover', icon: Compass },
  { path: '/public/screener', label: 'Research', icon: Search },
  sharedNav[0], // AI
  { path: '/public/portfolio', label: 'Portfolio', icon: Briefcase },
  sharedNav[1], // Watchlist
];

// Institutional (KubAIr Advisor OS) — B2B surface for SEBI-registered intermediaries.
const institutionalNav = [
  { path: '/public/home', label: 'Home', icon: LayoutDashboard },
  { path: '/public/clients', label: 'Clients', icon: Users },
  { path: '/public/signals', label: 'Signals', icon: Zap },
  { path: '/public/committee', label: 'Committee', icon: Gavel },
  { path: '/public/committee/portfolio', label: 'Portfolio', icon: Briefcase },
  { path: '/public/book', label: 'Book', icon: BookOpen },
  sharedNav[0], // AI
  { path: '/public/screener', label: 'Research', icon: Search },
  { path: '/public/ideas', label: 'Discover', icon: Compass },
  sharedNav[1], // Watchlist
  { path: '/public/team-chat', label: 'Team Chat', icon: MessageCircle },
  { path: '/public/org-settings', label: 'Organization', icon: Building2 },
];

/**
 * Returns the nav rail appropriate for the user type.
 * Retail users do NOT see advisor tooling (clients, proposals, team chat).
 */
export function getPublicNav(userType) {
  return userType === 'institutional' ? institutionalNav : retailNav;
}

// Default export preserved for any legacy import site; still role-aware consumers
// should call getPublicNav(userType) directly.
const publicNav = retailNav;

export const bottomNav = [
  { path: '/settings', label: 'Settings', icon: Settings },
];

export const discoverTabs = [
  { path: '/public/ideas', label: 'Ideas' },
  { path: '/public/top-movers', label: 'Top Movers' },
  { path: '/public/heatmap', label: 'Heatmap' },
  { path: '/public/money-flow', label: 'Money Flow' },
  { path: '/public/smart-money', label: 'Smart Money' },
  { path: '/public/sentiment', label: 'Sentiment' },
  { path: '/public/news', label: 'News' },
  { path: '/public/calendar', label: 'Calendar' },
];

export const researchTabs = [
  { path: '/public/screener', label: 'Explorer' },
  { path: '/public/scanners', label: 'TA Scanners' },
  { path: '/public/index-ta', label: 'Indices' },
  { path: '/public/stock-score', label: 'AI Score' },
  { path: '/public/insiders', label: 'Insiders' },
  { path: '/public/earnings', label: 'Earnings' },
  { path: '/public/debt-monitor', label: 'Debt Monitor' },
  { path: '/public/compare', label: 'Compare' },
  { path: '/public/directors', label: 'Directors' },
  { path: '/public/reports', label: 'Reports' },
];

export const portfolioTabs = [
  { path: '/public/portfolio', label: 'Overview' },
  { path: '/public/portfolio/holdings', label: 'Holdings' },
  { path: '/public/portfolio/performance', label: 'Performance' },
  { path: '/public/portfolio/news', label: 'News & Insights' },
  { path: '/public/portfolio/analytics', label: 'Analytics' },
  { path: '/public/portfolio/alerts', label: 'Alerts' },
  { path: '/public/portfolio/broker', label: 'Broker' },
  { path: '/public/watchlist', label: 'Watchlist' },
];

// These portfolio routes are retail-only (guarded in index.js). Institutional
// users who click them bounce back to Home, so they must be filtered out of the
// sub-nav on shared pages (Watchlist, Alerts).
const RETAIL_ONLY_PORTFOLIO_PATHS = new Set([
  '/public/portfolio',
  '/public/portfolio/holdings',
  '/public/portfolio/performance',
  '/public/portfolio/news',
  '/public/portfolio/analytics',
  '/public/portfolio/alerts',
  '/public/portfolio/broker',
]);

// Return the portfolio sub-nav tabs the given user type is actually allowed to
// open. Institutional users only keep the shared tabs (e.g. Watchlist).
export function portfolioTabsFor(userType) {
  if ((userType || '').toLowerCase() === 'institutional') {
    return portfolioTabs.filter((t) => !RETAIL_ONLY_PORTFOLIO_PATHS.has(t.path));
  }
  return portfolioTabs;
}

export default publicNav;
